import { PromotionRepository } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class GetPublicPromotionsUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(): Promise<PromotionEntity[]> {
    return this.promotionRepository.getPublicActive();
  }
}
